import React from 'react';
import { Link } from 'react-router-dom';

export const Card = ({ movie }) => {
  return (
    <div className='flex justify-center'>
      <div className='block max-w-sm rounded-lg bg-white shadow-lg dark:bg-neutral-700'>
        <Link to={`/movie/${movie.id}`}>
          <img
            className='rounded-t-lg'
            src={`https://www.themoviedb.org/t/p/w220_and_h330_face/${movie.poster_path}`}
            alt=''
          />
        </Link>
      </div>
    </div>
  );
};
